import { render } from "./JobListSection.vue?vue&type=template&id=07823ef1&scoped=true"
import script from "./JobListSection.vue?vue&type=script&lang=js"
export * from "./JobListSection.vue?vue&type=script&lang=js"

import "./JobListSection.vue?vue&type=style&index=0&id=07823ef1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07823ef1"]])

export default __exports__